<template>
    <div class="companies-view">
        <section class="companies-landing --tic">
            <div class="comp-logo"><img width="150px" src="../assets/imgs/icons/global-choices-logo-white.png"></div>
            <div class="intro-hd-container">
                <img src="../assets/imgs/icons/tic-graph.png">
                <img src="../assets/imgs/icons/tic-logo-white.png">
                 
                <p class="content-text --justify">
                We are passionate about improving people's performance - about rewarding them for their efforts and about achieving great results for our clients. We believe that people perform better when motivated, and that engaged staff improve a brand. Happy staff = happy customers. We believe it, we live it and we can deliver it to your company. We welcome the opportunity to become your incentive partner, and improve your bottom line. We are in the business of changing behaviour.</p>
                <button class="btn comps-btn">IMPROVE YOUR BOTTOM LINE</button>
            </div>

            <div class="social-icons-mobile">
                <ul class="social-items">
                    <li><a href="" class="facebook"></a></li>
                    <li><a href="" class="twitter"></a></li>
                    <li><a href="" class="linkedin"></a></li>
                    <li><a href="" class="instagram"></a></li>
                    <li><a href="" class="youtube"></a></li>
                </ul>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    
}
</script>

<style>

</style>
